module.exports = __webpack_public_path__ + "static/media/houzz.93b5963f.svg";